import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h2 className="hero-label">YOUR COMPLETE CRYPTO ECOSYSTEM</h2>
            <h1 className="hero-title">Buy cryptocurrency effortlessly</h1>
            <p className="hero-description">
              Easily calculate the exact amount of cryptocurrency you'll receive. Enter your details and let our calculator do the work in minutes.
            </p>
            <div className="hero-cta">
              <Link to="/signup" className="btn-hero-primary">Get started</Link>
              <a 
                href="#how-it-works" 
                className="btn-hero-secondary"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Learn more
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section id="how-it-works" className="how-it-works">
        <div className="container">
          <div className="section-header">
            <h2 className="section-label">Getting started</h2>
            <h3 className="section-title">Your cryptocurrency purchase journey</h3>
            <p className="section-description">Follow these straightforward steps to acquire digital assets using your preferred payment method</p>
          </div>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h4>Pick Your Digital Currency</h4>
              <p>Browse our selection of cryptocurrencies and specify the quantity you wish to purchase.</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h4>Submit Payment Information</h4>
              <p>Securely input your billing details and select from our range of accepted payment options.</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h4>Verify Transaction</h4>
              <p>Double-check all information displayed and proceed with finalizing your order.</p>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <h4>Get Your Digital Assets</h4>
              <p>After successful payment verification, your purchased cryptocurrency is immediately transferred to your designated wallet address.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Crypto Payment Processing */}
      <section className="crypto-payment">
        <div className="container">
          <div className="crypto-payment-content">
            <h2 className="section-label">Digital Currency Solutions</h2>
            <p className="crypto-payment-text">
              Discover the transformative power of blockchain technology and leverage the advantages of digital finance.
            </p>
            <p className="crypto-payment-text">
              Join the global transition to blockchain-based finance through our comprehensive service platform, enabling smooth transitions between traditional and digital currencies, complemented by robust asset protection.
            </p>
            <Link to="/signup" className="btn-primary">Get started</Link>
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section className="features">
        <div className="container">
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-accent"></div>
              <h3>Streamlined trading and conversion</h3>
            </div>
            <div className="feature-item">
              <div className="feature-accent"></div>
              <h3>Unified wallet management</h3>
            </div>
            <div className="feature-item">
              <div className="feature-accent"></div>
              <h3>Comprehensive portfolio insights</h3>
            </div>
            <div className="feature-item">
              <div className="feature-accent"></div>
              <h3>Next-generation financial technology</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose">
        <div className="container">
          <div className="section-header">
            <h2 className="section-label">Why QuantumSync</h2>
            <h3 className="section-title">What Sets Us Apart</h3>
            <p className="section-description">We streamline digital currency operations, making complex transactions simple and accessible.</p>
          </div>
          <div className="advantages">
            <div className="advantage">
              <div className="advantage-number">01</div>
              <h4>Rapid Processing</h4>
              <p>Your digital currency transactions complete within minutes. Time efficiency matters to us, and we guarantee prompt processing with minimal wait times.</p>
            </div>
            <div className="advantage">
              <div className="advantage-number">02</div>
              <h4>Market-Leading Rates</h4>
              <p>Access competitive conversion rates that work in your favor. We maintain complete pricing transparency with zero surprise charges, giving you full visibility into costs.</p>
            </div>
            <div className="advantage">
              <div className="advantage-number">03</div>
              <h4>Flexible Payment Solutions</h4>
              <p>Choose from multiple payment channels including credit cards, debit cards, and direct bank transfers. We accommodate diverse payment preferences to maximize convenience.</p>
            </div>
            <div className="advantage">
              <div className="advantage-number">04</div>
              <h4>Expert Support Available</h4>
              <p>Questions or need guidance? Our specialized support staff stands ready to assist around the clock. Reach out anytime and receive prompt, knowledgeable responses to all inquiries.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="services">
        <div className="container">
          <div className="section-header">
            <h2 className="section-label">Our Services</h2>
            <h3 className="section-title">Complete digital asset management platform</h3>
            <p className="section-description">Unify your cryptocurrency operations through QuantumSync and execute trades, purchases, and conversions effortlessly</p>
          </div>
          <div className="services-grid">
            <div className="service-item">
              <div className="service-accent"></div>
              <h4>Purchase Digital Assets</h4>
              <p>QuantumSync offers an efficient and user-friendly solution for acquiring cryptocurrencies through multiple channels including card payments, wire transfers, mobile payment systems, and additional supported methods.</p>
              <Link to="/signup" className="service-link">Purchase crypto</Link>
            </div>
            <div className="service-item">
              <div className="service-accent"></div>
              <h4>Token Exchange</h4>
              <p>Convert digital tokens between different blockchain networks using our advanced cross-chain infrastructure.</p>
              <Link to="/signup" className="service-link">Exchange tokens</Link>
            </div>
            <div className="service-item">
              <div className="service-accent"></div>
              <h4>Portfolio Management</h4>
              <p>Centralize your digital wallet collection with QuantumSync to monitor and analyze your investment performance with precision.</p>
              <Link to="/signup" className="service-link">Start managing</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Discover Us */}
      <section className="discover">
        <div className="container">
          <div className="section-header">
            <h2 className="section-label">About QuantumSync</h2>
            <h3 className="section-title">Your trusted digital currency partner</h3>
          </div>
          <div className="discover-grid">
            <div className="discover-item">
              <div className="discover-accent"></div>
              <h4>Proven Reliability</h4>
              <p>A dependable service provider delivering secure and efficient blockchain-based financial solutions.</p>
            </div>
            <div className="discover-item">
              <div className="discover-accent"></div>
              <h4>Intuitive Design</h4>
              <p>Built for ease of use, our platform delivers a smooth and straightforward digital asset trading interface.</p>
            </div>
            <div className="discover-item">
              <div className="discover-accent"></div>
              <h4>Enterprise-Grade Protection</h4>
              <p>Your security is paramount. We implement state-of-the-art cryptographic protocols and verified transaction systems.</p>
            </div>
            <div className="discover-item">
              <div className="discover-accent"></div>
              <h4>Worldwide Access</h4>
              <p>Available globally, enabling seamless participation in the international digital currency marketplace.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="faq">
        <div className="container">
          <div className="section-header">
            <h2 className="section-label">Common Questions</h2>
            <h3 className="section-title">Answers to Your Inquiries</h3>
            <p className="section-description">Need more details? Review our common questions below, or access our Support Portal for comprehensive guidance.</p>
          </div>
          <div className="faq-items">
            <div className="faq-item">
              <h4>Is QuantumSync safe for handling my digital currency transactions?</h4>
              <p>Without question! QuantumSync utilizes advanced protective technologies and maintains rigorous regulatory compliance to protect your assets and personal information. Security and client confidence remain our fundamental commitments.</p>
            </div>
            <div className="faq-item">
              <h4>How can I get in touch with QuantumSync support?</h4>
              <p>Connect with our assistance team via our Support Portal, which contains comprehensive resources and expert guidance on digital currency operations. We're available to address all your questions and provide solutions to any issues.</p>
            </div>
            <div className="faq-item">
              <h4>Does QuantumSync operate on a decentralized model?</h4>
              <p>Yes, QuantumSync follows a decentralized architecture. We do not maintain centralized custody of client digital assets. Every service we provide operates on a non-custodial basis, ensuring you maintain full control.</p>
            </div>
          </div>
          <div className="faq-cta">
            <Link to="/contact" className="btn-secondary">Visit Support Portal</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
